import React from 'react';
import { DateRange, Calendar } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import ja from 'date-fns/locale/ja';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import { DateHelper } from '../../../common/helper';
import { COLOR } from '../../common/constants';
export const ReactDateRange = (props) => {
    const { startDate, endDate, startTime, endTime, onChangeDateRange, onChangeStartTime, onChangeEndTime, disabled = false, isHide = false, isSingle = false, } = props;
    const selectionRange = {
        startDate,
        endDate,
        key: 'selection',
    };
    return (React.createElement(React.Fragment, null, isSingle ? (React.createElement(React.Fragment, null,
        React.createElement(SRow, null,
            React.createElement(SDateText, { disabled: disabled }, DateHelper.toStringDateOnly(startDate)),
            React.createElement(STextField, { type: "time", value: startTime, onChange: onChangeStartTime, disabled: disabled }),
            React.createElement("span", { style: { margin: '6px 8px 0 8px' } }, "\u301C"),
            React.createElement(STextField, { type: "time", value: endTime, onChange: onChangeEndTime, disabled: disabled })),
        !disabled && (React.createElement(Calendar, { date: startDate, locale: ja, onChange: onChangeDateRange, disabled: disabled, dateDisplayFormat: "yyyy/MM/dd" })))) : (React.createElement(React.Fragment, null, !isHide && (React.createElement(React.Fragment, null, disabled ? (React.createElement(SRow, null,
        React.createElement(SDateText, { disabled: disabled }, DateHelper.toStringDateOnly(startDate)),
        React.createElement("span", { style: { margin: '6px 8px 0 8px' } }, "\u301C"),
        React.createElement(SDateText, { disabled: disabled }, DateHelper.toStringDateOnly(endDate)))) : (React.createElement(DateRange, { ranges: [selectionRange], onChange: onChangeDateRange, locale: ja, dateDisplayFormat: "yyyy/MM/dd", disabled: disabled }))))))));
};
const SRow = styled.div `
  display: flex;
  align-items: center;
`;
const SDateText = styled.p `
  margin: 8px 16px 0 16px;
  color: ${({ disabled }) => disabled && COLOR.GRAY_500};
`;
const STextField = styled(TextField) `
  width: 100px;
`;
